const React = require('react');

/* eslint-disable */
module.exports = (props) => {
  return (
    <svg
      width="18"
      height="10"
      viewBox="0 0 18 10"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`dB fillCT>path ` + props.className || ''}
    >
      <path
        d="M5.46355 9.69017C5.11059 9.69017 4.76172 9.5614 4.49734 9.31034L0.400146 5.41958C-0.133382 4.91293 -0.133382 4.09182 0.400146 3.58582C0.933674 3.07917 1.79768 3.07917 2.3312 3.58582L5.62572 6.71434L15.5774 0.227585C16.1988 -0.177474 17.0492 -0.0273566 17.4758 0.562761C17.903 1.15353 17.7449 1.96041 17.1228 2.36611L6.23625 9.46305C6.00117 9.61576 5.73202 9.69017 5.46355 9.69017Z"/>
    </svg>
  );
};
